/**
 * Branded loading UI for auth routes — skeleton + shimmer, respects prefers-reduced-motion.
 */
export default function AuthBrandedLoader() {
  return (
    <div
      className="w-full min-h-[280px] flex flex-col items-center justify-center px-6 py-12 motion-reduce:animate-none"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">Loading page</span>
      <div className="w-full max-w-md space-y-6">
        <div className="flex flex-col items-center gap-4">
          <div className="auth-logo-skeleton h-16 w-16 rounded-full motion-reduce:animate-none" />
          <div className="h-4 w-40 rounded-sm bg-light-sidebar dark:bg-dark-sidebar auth-shimmer motion-reduce:animate-none" />
          <div className="h-3 w-24 rounded-sm bg-light-sidebar/80 dark:bg-dark-border auth-shimmer motion-reduce:animate-none [animation-delay:150ms]" />
        </div>
        <div className="space-y-3 pt-4">
          <div className="h-10 w-full rounded-sm bg-light-sidebar dark:bg-dark-sidebar auth-shimmer motion-reduce:animate-none" />
          <div className="h-10 w-full rounded-sm bg-light-sidebar dark:bg-dark-sidebar auth-shimmer motion-reduce:animate-none [animation-delay:100ms]" />
          <div className="h-10 w-full rounded-sm bg-light-sidebar dark:bg-dark-sidebar auth-shimmer motion-reduce:animate-none [animation-delay:200ms]" />
        </div>
        <div className="flex justify-center pt-2">
          <div className="flex gap-1.5">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="auth-dot-pulse h-1.5 w-1.5 rounded-full bg-primary-400 motion-reduce:animate-none"
                style={{ animationDelay: `${i * 160}ms` }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
